// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import {getFirestore} from 'firebase/firestore';
import { collection, addDoc } from "firebase/firestore"; 
import { getStorage } from "firebase/storage";


// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBwfejJKMMg_I9corg2tUkCk551FtH1Ki4",
  authDomain: "stlbundles.firebaseapp.com",
  projectId: "stlbundles",
  storageBucket: "stlbundles.appspot.com",
  messagingSenderId: "1086309059250",
  appId: "1:1086309059250:web:e878f1d4307cf9819ad7ab",
  measurementId: "G-32EHVELYX2"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
export const db = getFirestore(app)
export const storage = getStorage()
export default getFirestore()

